import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface OrganizationalStructure {
  id: string;
  department: string;
  headcount: number;
  key_focus_areas: string[];
  growth_plans: string;
}

export const OrganizationalStructure = () => {
  const { data: orgStructure, isLoading } = useQuery({
    queryKey: ['organizational-structure'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizational_structure')
        .select('*')
        .order('created_at', { ascending: true });

      if (error) throw error;
      return data as OrganizationalStructure[];
    },
  });

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-xl text-primary">Organizational Structure</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="animate-pulse space-y-4">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl text-primary">Organizational Structure</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Department</TableHead>
              <TableHead>Headcount</TableHead>
              <TableHead>Key Focus Areas</TableHead>
              <TableHead>Reduced to</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orgStructure?.map((dept) => (
              <TableRow key={dept.id}>
                <TableCell className="font-medium">{dept.department}</TableCell>
                <TableCell>{dept.headcount}</TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-2">
                    {dept.key_focus_areas.map((area, index) => (
                      <Badge key={index} variant="secondary">
                        {area}
                      </Badge>
                    ))}
                  </div>
                </TableCell>
                <TableCell>{dept.growth_plans}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};